import { Module } from "../module";
import { renderer } from "../rendering/RendererGlobals";
import { mainScene } from "../rendering/mainScene";
import { camera } from "../rendering/camera";
import { inputService } from "../inputs/input/InputService";
/**
 * Captures a high-resolution screenshot of the current scene from the user's perspective and downloads it locally for debugging or documentation purposes. It does not listen to bus messages, facets or model events - it is triggered directly through a UI button and a developer input action.
 */
export class ScreenshotModule extends Module {
    constructor() {
        super("ScreenshotModule");
        this.saveAsImage = () => {
            // simple 2d screenshot
            renderer.setSize(1920, 1080);
            renderer.render(mainScene, camera.perspectiveCam);
            try {
                const strMime = "image/jpeg";
                const strDownloadMime = "image/octet-stream";
                const imgData = renderer.domElement.toDataURL(strMime);
                this.saveFile(imgData.replace(strMime, strDownloadMime), "vrscreenshot.jpg");
            }
            catch (e) {
                console.error(e);
                return;
            }
            // reset renderer size
            const worldContainer = document.getElementById("world-container");
            if (worldContainer) {
                renderer.setSize(worldContainer.offsetWidth, worldContainer.offsetHeight);
            }
            else {
                renderer.setSize(window.innerWidth, window.innerHeight);
            }
        };
    }
    /**
     * Wires the "save-screenshot" UI button and a dev-only input action (period key) to trigger `saveAsImage`.
     */
    init() {
        const button = document.getElementById("save-screenshot");
        if (button !== null) {
            button.addEventListener("click", this.saveAsImage);
        }
        inputService
            .registerAction("Screenshot", () => {
            this.saveAsImage();
        }, "Screenshot of the scene from my current perspective")
            .addKey("Period")
            .asDev();
    }
    saveFile(strData, filename) {
        const link = document.createElement("a");
        if (typeof link.download === "string") {
            document.body.appendChild(link); // Firefox requires the link to be in the body
            link.download = filename;
            link.href = strData;
            link.click();
            document.body.removeChild(link); // remove the link when done
        }
    }
}
